import { render, staticRenderFns } from "./SwiperSlide.vue?vue&type=template&id=48dfc18d&scoped=true&"
import script from "./SwiperSlide.vue?vue&type=script&lang=js&"
export * from "./SwiperSlide.vue?vue&type=script&lang=js&"
import style0 from "./SwiperSlide.vue?vue&type=style&index=0&id=48dfc18d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dfc18d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48dfc18d')) {
      api.createRecord('48dfc18d', component.options)
    } else {
      api.reload('48dfc18d', component.options)
    }
    module.hot.accept("./SwiperSlide.vue?vue&type=template&id=48dfc18d&scoped=true&", function () {
      api.rerender('48dfc18d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/components/vue/swiper/SwiperSlide.vue"
export default component.exports